import {
    ApiResponse,
    get,
    post,
} from '../../utils/services';
import type { LoanPurposeResponse, UpdateLoanPurposeRequest  } from './loanPurposeTypes';

export const fetchLoanPurposeApi = (
    url: string,
): Promise<ApiResponse<LoanPurposeResponse>> => get( url );

export const updateLoanPurposeApi = (
    url: string,
    payload: UpdateLoanPurposeRequest,
): Promise<ApiResponse<UpdateLoanPurposeRequest>> => post({ url, payload });
